function getEstimatedDeliveryTime(vendor) {
  // Get today's date
  const now = new Date();
  let startDate = new Date(now);

  // If weekend, adjust to next business day
  const dayOfWeek = now.getDay(); // 0 = Sunday, 6 = Saturday
  if (dayOfWeek === 6) {
    startDate.setDate(startDate.getDate() + 2); // Saturday → Monday
  } else if (dayOfWeek === 0) {
    startDate.setDate(startDate.getDate() + 1); // Sunday → Monday
  }

  let fromDate = new Date(startDate);
  let toDate = new Date(startDate);
  let showDelivery = false;

  if (vendor === "Maxton Design") {
    fromDate.setDate(fromDate.getDate() + 35);
    toDate.setDate(toDate.getDate() + 56);
    showDelivery = true;
  } else if (vendor === "Sprint Filter") {
    fromDate.setDate(fromDate.getDate() + 14);
    toDate.setDate(toDate.getDate() + 21);
    showDelivery = true;
  }

  if (showDelivery) {
    const formatOptions = { weekday: "long", month: "long", day: "numeric" };

    const fromYear = fromDate.getFullYear();
    const toYear = toDate.getFullYear();
    const currentYear = now.getFullYear();

    const fromStr = `${fromDate.toLocaleDateString(undefined, formatOptions)}${
      fromYear !== currentYear ? `, ${fromYear}` : ""
    }`;
    const toStr = `${toDate.toLocaleDateString(undefined, formatOptions)}${
      toYear !== currentYear ? `, ${toYear}` : ""
    }`;

    const etaString = `${fromStr} – ${toStr}`;

    return {
      etaString: etaString,
      latestDate: toDate,
    };
  }

  return {
    etaString: "",
    latestDate: null,
  };
}
